// Splide init
function mmInitSplide() {
	const id = ".splide-mm-cart";
	const splideElem = document.querySelector(id);

	if (splideElem) {
		new Splide(splideElem, {
			type: "slide",
			arrows: true,
			pagination: false,
			gap: 12,
			perPage: 1,
			autoWidth: true,
		}).mount();
	}
}

document.addEventListener(
	"DOMContentLoaded",
	() => {
		mmInitSplide();
	},
	{ once: true }
);

// Debounce
// https://redd.one/blog/debounce-vs-throttle
// If function is called several times in {duration},
// wait for a pause longer than {duration} to actually trigger it.
// eg, wait 500 milliseconds after last call to actually call doSomething():
// debounce(function () {
//    doSomething();
//  }, 500)
function debounce(func, duration) {
	let timeout;

	return function (...args) {
		const effect = () => {
			timeout = null;
			return func.apply(this, args);
		};
		clearTimeout(timeout);
		timeout = setTimeout(effect, duration);
	};
}

function mmCartSectionElement() {
	return document.querySelector(".shopify-section-mm-cart");
}

function mmCartProductsContainerElement() {
	return mmCartSectionElement().querySelector(".mm-dc-products-container");
}

function mmCartItem(productVariantId) {
	return mmCartProductsContainerElement().querySelector(`[data-cart-item-id="${productVariantId}"]`);
}

function mmCartItemQuantityEl(productVariantId) {
	const itemEl = mmCartItem(productVariantId);

	return itemEl.querySelector("[data-item-quantity]");
}

function mmGetCartItemQuantity(productVariantId) {
	const quantityEl = mmCartItemQuantityEl(productVariantId);

	return Number.parseInt(quantityEl.dataset.itemQuantity);
}

function mmSetCartItemQuantity(productVariantId, newQuantity) {
	if (newQuantity >= 0) {
		const quantityEl = mmCartItemQuantityEl(productVariantId);

		quantityEl.dataset.itemQuantity = newQuantity;
		quantityEl.innerText = newQuantity;
	}
}

function mmCartHTMLFromData(data) {
	const el = document.createElement("DIV");
	el.innerHTML = data.sections["mm-cart"];

	return el;
}

function extractItemsFromCartHTML(data) {
	const el = mmCartHTMLFromData(data);
	return el.querySelector(".mm-dc-products-container");
}

function insertCartProductsFromResponse(data) {
	const itemsContainer = extractItemsFromCartHTML(data);
	mmCartProductsContainerElement().innerHTML = itemsContainer.innerHTML;

	const diagnosticCartItems = document.querySelector('#diagnostic-cart-items');
	if (diagnosticCartItems) {
		diagnosticCartItems.innerHTML = itemsContainer.querySelector('.mm-dc-products-items').innerHTML
	}

	return data;
}

function extractTotalPriceFromCartHTML(data) {
	const cartEl = mmCartHTMLFromData(data); // ¡ fait atención gringo !
	return cartEl.querySelector("[data-cart-total-price]");
}

function insertInsertTotalPriceFromResponse(data) {
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
	const currentTotalPriceEl = mmCartSectionElement().querySelector("[data-cart-total-price]");
	currentTotalPriceEl.innerHTML = newTotalPriceEl.innerHTML;

	const diagnosticTotalPrice = document.querySelector('diagnostic-cart [data-cart-total-price]');
	if (diagnosticTotalPrice) {
		diagnosticTotalPrice.innerHTML = newTotalPriceEl.innerHTML;
	}
 
	return data;
}

function mmAPIRequest(method, path, body) {
	document.querySelector(".mm-dc-products")?.classList.add("mm-inactive");
	return fetch(window.Shopify.routes.root + path, {
		method: method,
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(body),
	}) 
		.then((response) => response.json())
		.then((data) => {
			document.querySelector(".mm-dc-products")?.classList.remove("mm-inactive");
			if (mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner")) {
				const freeItemsProgress = mmCartSectionElement().querySelector(".mm-dc-free-item-progress--inner");
				const newWidth = (data.total_price / document.getElementById("mmCartProgressBarValue").value) * 100;
				freeItemsProgress.style.width = `${newWidth}%`;

				//Hidden footer cart empty
				var cartFooter = document.querySelector(".mm-dc-bottom");
				if (data.total_price == 0) {
					cartFooter.classList.add("mm-none");
				} else {
					cartFooter.classList.remove("mm-none");
				}

				if (data.total_price >= document.getElementById("mmCartProgressBarValue").value) {
					document.querySelector(".mm-dc-free-item-progress-text_succes").style.display = "block";
					document.querySelector(".mm-dc-free-item-progress-text_not_yet").style.display = "none";
				} else {
					document.querySelector(".mm-dc-free-item-progress-text_succes").style.display = "none";
					document.querySelector(".mm-dc-free-item-progress-text_not_yet").style.display = "block";
				}
				const montantRestant = document.querySelector(".mm-dc-free-item-progress-text span");
				if (montantRestant) {
					montantRestant.innerText = ((document.getElementById("mmCartProgressBarValue").value - data.total_price) / 100).toFixed(2).replace(/\./g, "€").replace(/00/g, "");
				}
			}
			updateCartCount(data.item_count != null ? data.item_count : 0);
			return data;
		})
		.then((data) => {
			console.log('DATA', data);
			if (data.status && data.status > 400) {
				throw data;
			} else {

				clearCartSectionData(data);

				return data;
			}
		});
}

function clearCartSectionData(data) {
	// Check if sections data exists
	if (!data.sections || !data.sections['mm-cart']) {
		return;
	}

	// Create a temporary container to parse the HTML
	var tempDiv = document.createElement('div');
	tempDiv.innerHTML = data.sections['mm-cart'];

	// Find the empty buttons container
	var emptyBtnsContainer = tempDiv.querySelector('.mm-dc-empty-btns-container.mm-flex.mm-wrap');

	if (emptyBtnsContainer) {
		// Get all button elements
		var buttons = emptyBtnsContainer.querySelectorAll('.mm-btn-primary.mm-btn-primary-with-arrow');

		// Remove the last button if it exists
		if (buttons.length > 0) {
			var lastButton = buttons[buttons.length - 1];
			lastButton.remove();
		}

		// Update the data object with the modified HTML
		data.sections['mm-cart'] = tempDiv.innerHTML;
	}
}

// run cart.js
function fetchCartJs() {
	mmAPIRequest("GET", "cart.js");
}

// récupérer le panier
function mmGetCart() {
	mmAPIRequest("GET", "cart.js").then(console.log);
}

// Ouvrir le panier
function mmOpenCart() {
	document.querySelector(".mm-drawer-cart-filter").classList.add("mm-dc-is-open");
	document.querySelector("html").classList.add("stop-scrolling");
}

// Fermer le panier
function mmCloseCart() {
	document.querySelector(".mm-drawer-cart-filter").classList.remove("mm-dc-is-open");
	document.querySelector("html").classList.remove("stop-scrolling");
}

// Re-render cart inner HTML from response
function refreshCartFromData(data) {
	console.log('data', data);
	const newCartEl = document.createElement("DIV");
	newCartEl.innerHTML = data.sections["mm-cart"];
	const newTotalPriceEl = extractTotalPriceFromCartHTML(data);
	const innerCart = mmCartSectionElement().querySelector(".mm-drawer-cart-filter");
	innerCart.innerHTML = newCartEl.querySelector(".mm-drawer-cart-filter").innerHTML;
	updateCartCount(newCartEl.querySelector("[data-cart-count]").dataset.cartCount);
	mmInitSplide();

	const diagnosticCartItems = document.querySelector('#diagnostic-cart-items');
	if (diagnosticCartItems) {
		diagnosticCartItems.innerHTML = newCartEl.querySelector(".mm-dc-products-items").innerHTML;
	}
 
	const diagnosticTotalPrice = document.querySelector('diagnostic-cart [data-cart-total-price]');
	if (diagnosticTotalPrice) {
		diagnosticTotalPrice.innerHTML = newTotalPriceEl.innerHTML;
	}

}

// Ajouter un item au panier
function mmAddProductToCart(productId, quantity = 1, aboInput = null) {
	console.log('mmAddProductToCart');
	if (aboInput != null && aboInput.id.includes("option-1")) {
		let sellingPlanValue;
		const select = document.getElementById("mmRcSelect");
		const radioSelect = document.getElementById("mmRcRadio");

		if (select) {
			sellingPlanValue = select.value;
		} else if (radioSelect) {
			sellingPlanValue = radioSelect.querySelector('input[name="selling_plan"]:checked').value;
		}

		mmAPIRequest("POST", "cart/add.js", {
			items: [{ quantity: quantity, id: productId, selling_plan: sellingPlanValue }],
			sections: "mm-cart",
		})
			.then(refreshCartFromData)
			.then((data) => {
				setTimeout(mmOpenCart);
			})
			.catch((error) => {
				mmCartProductsContainerElement().innerHTML = `
      Oups, il y a eu une erreur, essayez de recharger la page !
      `;
				mmOpenCart();
				console.log(error);
			});
	} else {
		var crossSellEl = document.querySelector('.mm-dc-cross-sell');
		var dataMobileEl = document.querySelector('.mm-mobile-block');

		console.log('crossSellEl', crossSellEl);

		mmAPIRequest("POST", "cart/add.js", {
			items: [{ quantity: quantity, id: productId }],
			sections: "mm-cart",
		})
			.then(refreshCartFromData)
			.then((data) => {

			mmAPIRequest("GET", "cart.js")
			.then((response) => {
				console.log('RESPONSE', response);

				if(response.items.length === 1) {
					console.log('RENDER complementary products');
					const productId = response.items[0].product_id;
					// Return the promise to chain it
					return getComplementaryProducts(productId)
						.then((products) => {
							console.log('COMPLEMENTARY PRODUCTS', products);

							if(products.length > 0) {
								// Build cross-sell HTML with complementary products for desktop
								const crossSellHtml = buildCrossSellHtml(products);
								crossSellEl = crossSellHtml;
								console.log('crossSellHtml', crossSellEl);

								// Build mobile cross-sell HTML
								const mobileCrossSellHtml = buildMobileCrossSellHtml(products);
								dataMobileEl = mobileCrossSellHtml;
								console.log('mobileCrossSellHtml', dataMobileEl);
							}
						});
				}
				// If not one item, return resolved promise to continue chain
				return Promise.resolve();

			}).then(() => {
				setTimeout(() => {
					appendCrossSell(crossSellEl, dataMobileEl);
					mmOpenCart();
				});
			})

			})
			.catch((error) => {
				mmCartProductsContainerElement().innerHTML = `
        Oups, il y a eu une erreur, essayez de recharger la page !
        `;
				mmOpenCart();
				console.log(error);
			});
	}

}

function getComplementaryProducts(productId, intent = 'complementary', limit = 4) {
	const url = `/recommendations/products.json?product_id=${productId}&intent=${intent}&limit=${limit}`;

	return fetch(url)
		.then(function(response) {
			if (!response.ok) throw new Error('Network response was not ok');
			return response.json();
		})
		.then(function(data) {
			if (!data.products || data.products.length === 0) {
				return [];
			}
			return data.products;
		})
		.catch(function(error) {
			console.error('Error fetching complementary products:', error);
			return [];
		});
}

function buildCrossSellHtml(products) {
	// Create container element
	const container = document.createElement('div');
	container.className = 'mm-dc-cross-sell mm-column mm-desktop';

	// Add title
	const title = document.createElement('span');
	title.className = 'mm-dc-cross-sell--title';
	title.textContent = 'Vous aimerez aussi';
	container.appendChild(title);

	// Create products container
	const productsContainer = document.createElement('div');
	productsContainer.className = 'mm-shopify-recos-container';

	// Add each product
	products.forEach(function(product) {
		const productDiv = document.createElement('div');
		productDiv.className = 'mm-dc-product';
		productDiv.setAttribute('data-cart-item-id', product.variants[0].id);

		// Format price
		const price = (product.price / 100).toFixed(2).replace('.', ',').replace(',', '€');

		productDiv.innerHTML = `
			<div class="mm-dc-product-image">
				<img
					src="${product.featured_image}"
					alt="${product.title}"
					width="auto"
					height="auto"
					loading="lazy"
				/>
			</div>
			<div class="mm-dc-product-content">
				<p class="mm-dc-product-title">${product.title}</p>
				${product.metafields?.custom?.info ? `<p class="mm-dc-product-mf">${product.metafields.custom.info}</p>` : ''}
				<div class="mm-dc-product-qqty mm-pr-upsell-price mm-bold-700 mm-cerebri-bold mm-cursor-pointer"
					 onclick="mmAddProductToCart(${product.variants[0].id}, { openCart: false })">
					AJOUTER - ${price}
				</div>
			</div>
		`;

		productsContainer.appendChild(productDiv);
	});

	container.appendChild(productsContainer);
	return container;
}

function buildMobileCrossSellHtml(products) {
	// Create mobile container
	const mobileBlock = document.createElement('div');
	mobileBlock.className = 'mm-mobile-block';

	// Create inner structure
	const crossSellDiv = document.createElement('div');
	crossSellDiv.className = 'mm-dc-cross-sell';

	// Add title
	const title = document.createElement('h3');
	title.className = 'mm-dc-cross-sell--title';
	title.textContent = 'Vous aimerez aussi';
	crossSellDiv.appendChild(title);

	// Create Splide structure
	const splideDiv = document.createElement('div');
	splideDiv.className = 'splide splide-mm-cart';

	// Create arrows
	const arrowsDiv = document.createElement('div');
	arrowsDiv.className = 'splide__arrows';
	arrowsDiv.innerHTML = `
		<button class="splide__arrow splide__arrow--prev">
			<svg width="37" height="38" viewBox="0 0 37 38" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="0.5" y="0.5" width="36" height="37" rx="18" fill="#FFFCF8"></rect>
				<path d="M19.4492 11.9492L26.4999 18.9999L19.4492 26.0507" stroke="#6F2B1C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
				<path d="M26.4999 18.9999L11.5 18.9999" stroke="#6F2B1C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
				<rect x="0.5" y="0.5" width="36" height="37" rx="18" stroke="#6F2B1C"></rect>
			</svg>
		</button>
		<button class="splide__arrow splide__arrow--next">
			<svg width="37" height="38" viewBox="0 0 37 38" fill="none" xmlns="http://www.w3.org/2000/svg">
				<rect x="0.5" y="0.5" width="36" height="37" rx="18" fill="#FFFCF8"></rect>
				<path d="M19.4492 11.9492L26.4999 18.9999L19.4492 26.0507" stroke="#6F2B1C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
				<path d="M26.4999 18.9999L11.5 18.9999" stroke="#6F2B1C" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"></path>
				<rect x="0.5" y="0.5" width="36" height="37" rx="18" stroke="#6F2B1C"></rect>
			</svg>
		</button>
	`;
	splideDiv.appendChild(arrowsDiv);

	// Create track and list
	const trackDiv = document.createElement('div');
	trackDiv.className = 'splide__track';

	const listUl = document.createElement('ul');
	listUl.className = 'splide__list';

	// Add products as slides
	products.forEach(function(product) {
		const slideLi = document.createElement('li');
		slideLi.className = 'splide__slide';

		// Format price
		const price = (product.price / 100).toFixed(2).replace('.', ',').replace(',', '€');

		slideLi.innerHTML = `
			<div class="mm-dc-product" data-cart-item-id="${product.variants[0].id}">
				<div class="mm-dc-product-image">
					<img
						src="${product.featured_image}"
						alt="${product.title}"
						width="auto"
						height="auto"
						loading="lazy"
					/>
				</div>
				<div class="mm-dc-product-content">
					<p class="mm-dc-product-title">${product.title}</p>
					${product.metafields?.custom?.info ? `<p class="mm-dc-product-mf">${product.metafields.custom.info}</p>` : ''}
					<div class="mm-dc-product-qqty mm-pr-upsell-price mm-bold-700 mm-cerebri-bold mm-cursor-pointer"
						 onclick="mmAddProductToCart(${product.variants[0].id}, { openCart: false })">
						AJOUTER - ${price}
					</div>
				</div>
			</div>
		`;

		listUl.appendChild(slideLi);
	});

	trackDiv.appendChild(listUl);
	splideDiv.appendChild(trackDiv);
	crossSellDiv.appendChild(splideDiv);
	mobileBlock.appendChild(crossSellDiv);

	return mobileBlock;
}

function appendCrossSell(crossSellEl, dataMobile) {
	console.log('appendCrossSell', crossSellEl, dataMobile);
	const containerEl = document.querySelector('.mm-dc-upsell-cart');

	// Remove existing desktop cross-sell element if it exists
	const existingCrossSell = containerEl.querySelector('.mm-dc-cross-sell.mm-column.mm-desktop');
	if (existingCrossSell) {
		existingCrossSell.remove();
	}

	containerEl.prepend(crossSellEl);

	// Remove existing mobile cross-sell element if it exists
	const productsContainerEl = document.querySelector('.mm-dc-products-container');
	const existingMobileCrossSell = productsContainerEl.nextElementSibling;
	if (existingMobileCrossSell && existingMobileCrossSell.classList.contains('mm-mobile-block')) {
		existingMobileCrossSell.remove();
	}

	productsContainerEl.after(dataMobile);

	// Reinitialize Splide for mobile
	setTimeout(() => {
		mmInitSplide();
	}, 100);
}

function mmIncreaseProductQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity + 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmDecreaseProductQuantity(productVariantId) {
	console.log('mmDecreaseProductQuantity');
	const quantity = mmGetCartItemQuantity(productVariantId);
	const newQuantity = quantity - 1;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmDestroyProductFromCart(productVariantId) {
	const newQuantity = 0;
	mmSetCartItemQuantity(productVariantId, newQuantity);

	mmDebouncedPushNewQuantity(productVariantId);
}

function mmPushNewQuantity(productVariantId) {
	const quantity = mmGetCartItemQuantity(productVariantId);

	mmAPIRequest("POST", "cart/change.js", {
		id: productVariantId.toString(),
		quantity: quantity,
		sections: "mm-cart",
	})
		.then(insertCartProductsFromResponse)
		.then(insertInsertTotalPriceFromResponse)
		.then(mmAddOrRemoveFreeProducts)
		.then(fetchCartJs);
}

const mmDebouncedPushNewQuantity = debounce(function (productVariantId) {
	mmPushNewQuantity(productVariantId);
}, 300);

function mmAddOrRemoveFreeProducts(data) {
	if (data.sections["mm-cart"]) {
		const el = mmCartHTMLFromData(data);
		const freeProductEls = el.querySelector("[data-free-products]");
		let freeProductCounts = 0;

		// creates an object like { 44058675: 1, 44058001: 0 }
		// where key is free product id and value, its quantity
		const productsParams = Array.from(freeProductEls.children).reduce((param, freeProductEl) => {
			const productId = freeProductEl.dataset.productId;
			const isFree = freeProductEl.dataset.freeProduct == "true";
			const itemEl = mmCartItem(productId);
			if (isFree) {
				freeProductCounts += 1;
			}
			if (itemEl && isFree) {
				// do nothing, item is already added
			} else if (itemEl && !isFree) {
				// item is present but should be removed
				param[productId] = 0;
			} else if (!itemEl && isFree) {
				// item is absent but should be added
				param[productId] = 1;
			}
			return param;
		}, {});

		// Add or remove free products only if needed
		if (Object.keys(productsParams).length > 0) {
			mmAPIRequest("POST", "cart/update.js", { updates: productsParams, sections: "mm-cart" }).then(insertCartProductsFromResponse);
		}
	}
	return data;
}

function updateCartCount(value) {
	var cartCountValues = document.querySelectorAll(".js-cart-count-bubble");
	cartCountValues.forEach(function (cartCountValue) {
		if (value != 0) {
			cartCountValue.innerText = value;
			cartCountValue.style.display = "flex";
		} else {
			cartCountValue.style.display = "none";
			cartCountValue.textContent = '0';
		}
	});
}

async function updateProductFromCart(lineItemId, quantity, selling_plan) {
	let data = '';

	data = {
		id: lineItemId,
		quantity: quantity,
		selling_plan: (selling_plan && selling_plan !== 'onetime') ? selling_plan : null,
		sections: "mm-cart"
	};

	mmAPIRequest("POST", "cart/change.js", data)
		.then(insertCartProductsFromResponse)
		.then(insertInsertTotalPriceFromResponse)
		.then(mmAddOrRemoveFreeProducts);
}

class sellingPlanSelector extends HTMLElement {
	constructor() {
		super();
		this.id = this.dataset.variant;
		this.quantity = this.dataset.quantity;
		this.select = this.querySelector("jolly-subscription-dropdown");
		this.dropdownInputs = this.querySelectorAll("[dropdown-input]");
		this.applySellingPlan = this?.querySelector('[js-selling-plan-apply]');

		this.dropdownInputs.forEach((input) => {
			input.addEventListener("change", () => {
				let selling_plan_id = this.select.querySelector('[dropdown-input]:checked').value;
				let lineItemId = this.id;
				let quantity = this.quantity;

				updateProductFromCart(lineItemId, quantity, selling_plan_id);
			});
		});

		if (!this.applySellingPlan) {
			return;
		}

		this.applySellingPlan.addEventListener('click', (e) => {
			e.preventDefault();

			this.dropdownInputs[1].checked = true;
			this.dropdownInputs[1].dispatchEvent(new Event("change"));
		});
	}
}

customElements.define("selling-plan", sellingPlanSelector);

class JollySubscriptionDropdown extends HTMLElement {
	constructor() {
		super();
		this.elements = {
			setValue: this.querySelector('[data-option-dropdown-value]'),
			getValue: this.querySelector('[dropdown-input]:checked'),
			selectBox: this.querySelector('[data-option-dropdown-block]'),
			valueBox: this.querySelector('[data-option-dropdown-items]'),
		};
	}

	connectedCallback() {
		this.elements.setValue.innerHTML = this.elements.getValue.dataset.textValue;

		if (this.elements.valueBox.querySelectorAll("[dropdown-input]").length > 1) {
			this.elements.selectBox.addEventListener("click", () => {
				document.querySelectorAll("[data-option-dropdown-block].open").forEach((block) => {
					if (block != this.elements.selectBox) {
						this.toggleDropdown(block, block, block.nextElementSibling);
					}
				});
				this.toggleDropdown(this.elements.selectBox, this.elements.selectBox, this.elements.valueBox);
			});
		} else {
			this.elements.selectBox.querySelector("svg").classList.add("jc-hidden")
		}

		document.addEventListener("click", (e) => {
			if (!e.target.closest("jolly-subscription-dropdown")) {
				document.querySelectorAll("[data-option-dropdown-block].open").forEach((block) => {
					this.toggleDropdown(block, block, block.nextElementSibling);
				});
			}
		});

		if (this.dataset.requireFetch === "false") {
			this.querySelectorAll('[dropdown-input]').forEach(input => {
				input.addEventListener('click', () => {
					this.elements.setValue.innerHTML = input.dataset.textValue;
					document.querySelectorAll("[data-option-dropdown-block].open").forEach((block) => {
						this.toggleDropdown(block, block, block.nextElementSibling);
					});
				});
			});
		}
	}

	toggleDropdown(firstEl, secondEl, thirdEl) {
		firstEl.classList.toggle("open");
		secondEl.querySelector("svg").classList.toggle("jc-rotate-180");
		thirdEl.classList.toggle("jc-hidden");
	}
}

customElements.define('jolly-subscription-dropdown', JollySubscriptionDropdown);

class upsellAddToCart extends HTMLElement {
	constructor() {
		super();

		this.elements = {
			addBtn: this.querySelector('[js-add-to-cart-btn]'),
			variantInput: this.querySelector('[name="id"]'),
			subscriptionDropdown: this.querySelector('jolly-subscription-dropdown'),
			enableSellingPlan: this.querySelector('[js-enable-selling-plan]'),
		}
	}

	connectedCallback() {
		this.elements.addBtn.addEventListener('click', () => {
			let sellingPlanValue = null;
			if (this.elements.enableSellingPlan && this.elements.subscriptionDropdown && this.elements.enableSellingPlan?.checked) {
				sellingPlanValue = this.elements.subscriptionDropdown.querySelector('[dropdown-input]:checked').value;
			}
			this.addToCart(this.elements.variantInput.value, 1, sellingPlanValue);
		});
	}

	addToCart(variantId, quantity = 1, sellingPlanValue) {
		mmAPIRequest("POST", "cart/add.js", {
			items: [{ quantity: quantity, id: variantId, selling_plan: sellingPlanValue }],
			sections: "mm-cart",
		})
			.then(refreshCartFromData)
			.catch((error) => {
				mmCartProductsContainerElement().innerHTML = `
					Oops, there was an error, try reloading the page!
				`;
				console.log(error);
			});
	}
}

customElements.define("jolly-upsell-add-to-cart", upsellAddToCart);